import { useTranslation } from 'react-i18next';

import { useAuth } from '@saas-kit/lib';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  EmptyState,
  PageHeader,
} from '@saas-kit/ui';

export function AdminHomePage(): JSX.Element {
  const { t } = useTranslation('adminHome');
  const user = useAuth((s) => s.user);

  return (
    <div className="space-y-6">
      <PageHeader title={t('title')} description={t('subtitle')} />

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>{t('session.title')}</CardTitle>
            <CardDescription>{t('session.description')}</CardDescription>
          </CardHeader>
          <CardContent>
            <dl className="grid gap-3 text-sm">
              <SummaryRow label={t('session.email')} value={user?.email ?? '—'} />
              <SummaryRow label={t('session.actor')} value={t('session.actor_value')} />
              <SummaryRow
                label={t('session.permissions')}
                value={String(user?.effective_permissions.length ?? 0)}
              />
            </dl>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>{t('next.title')}</CardTitle>
            <CardDescription>{t('next.description')}</CardDescription>
          </CardHeader>
          <CardContent>
            <EmptyState
              title={t('next.placeholder_title')}
              description={t('next.placeholder_body')}
              className="border-solid bg-muted/20 py-10"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

function SummaryRow({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <div className="flex flex-col gap-0.5">
      <dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className="text-foreground">{value}</dd>
    </div>
  );
}
